<template>
  <div class="container-profile">
    <Memento />
    <b-row>
      <b-col>
        <b-card class="card-student" header="СУРАЛЦАГЧИЙН МЭДЭЭЛЭЛ">
          <profile-row
            label="Нэр"
            :value="data.childName"
            paramName="childName"
          ></profile-row>
          <profile-row
            label="Аймаг/дүүрэг"
            :value="data.childPlaceId"
            :choices="Country"
            paramName="childPlaceId"
          ></profile-row>
          <profile-row
            label="Сургууль"
            :value="data.childSchool"
            paramName="childSchool"
          ></profile-row>
          <profile-row
            label="Анги"
            :value="data.childClass"
            :choices="classily"
            paramName="childClass"
          ></profile-row>
          <profile-row
            label="Бүлэг"
            :value="data.childBuleg"
            paramName="childBuleg"
          ></profile-row>
          <profile-row
            label="Төрсөн он"
            :value="data.childBday"
            paramName="childBday"
            :validator="validateByear"
          ></profile-row>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="parent-information" header="ЭЦЭГ ЭХИЙН МЭДЭЭЛЭЛ">
          <profile-row
            label="Овог"
            :value="data.parentLastname"
            paramName="parentLastname"
          ></profile-row>
          <profile-row
            label="Нэр"
            :value="data.parentFirstname"
            paramName="parentFirstname"
          ></profile-row>
          <profile-row
            label="И-мэйл хаяг"
            :value="data.parentEmail"
            paramName="parentEmail"
            :validator="validateEmail"
          ></profile-row>
          <div class="profile">
            <div>Утас</div>
            <div>{{ data.loginName }}</div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import TestChart from "../components/TestChart.vue";
import Memento from "../components/Memento.vue";
import OwnerService from "../api-services/owner.service.js";
import ProfileRow from "../components/profile-row.vue";
import Swal from "sweetalert2";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  timer: 3000,
  timerProgressBar: true,
  showConfirmButton: false,
});
export default {
  components: {
    // TestChart,
    Memento,
    ProfileRow,
  },
  data() {
    return {
      slide: 0,
      testResultData: [
        {
          data: [50, 70, 100],
          isCompleted: true,
        },
        { data: [70, 50, 40], isCompleted: false },
        { data: [80, 70, 30], isCompleted: false },
        { data: [0, 0, 0], isCompleted: false },
        { data: [0, 0, 0], isCompleted: false },
      ],
      data: {},
      classily: [
        { value: "1", text: "1-р анги" },
        { value: "2", text: "2-р анги" },
        { value: "3", text: "3-р анги" },
        { value: "4", text: "4-р анги" },
        { value: "5", text: "5-р анги" },
        { value: "6", text: "6-р анги" },
        { value: "7", text: "7-р анги" },
        { value: "8", text: "8-р анги" },
        { value: "9", text: "9-р анги" },
        { value: "10", text: "10-р анги" },
        { value: "11", text: "11-р анги" },
        { value: "12", text: "12-р анги" },
      ],
      Country: [
        { value: 1, text: "Архангай" },
        { value: 2, text: "Баян-Өлгий" },
        { value: 3, text: "Баянхонгор" },
        { value: 4, text: "Булган" },
        { value: 5, text: "Говь-Алтай" },
        { value: 6, text: "Говьсүмбэр" },
        { value: 7, text: "Дархан-Уул" },
        { value: 8, text: "Дорноговь" },
        { value: 9, text: "Дорнод" },
        { value: 10, text: "Дундговь" },
        { value: 11, text: "Завхан" },
        { value: 12, text: "Орхон" },
        { value: 13, text: "Өвөрхангай" },
        { value: 14, text: "Өмнөговь" },
        { value: 15, text: "Сүхбаатар" },
        { value: 16, text: "Сэлэнгэ" },
        { value: 17, text: "Төв" },
        { value: 18, text: "Увс" },
        { value: 19, text: "Ховд" },
        { value: 20, text: "Хөвсгөл" },
        { value: 21, text: "Хэнтий" },
        { value: 22, text: "Улаанбаатар - Багануур" },
        { value: 23, text: "Улаанбаатар - Баянгол" },
        { value: 24, text: "Улаанбаатар - Баянзүрх" },
        { value: 25, text: "Улаанбаатар - Налайх" },
        { value: 26, text: "Улаанбаатар - Чингэлтэй" },
        { value: 27, text: "Улаанбаатар - Сүхбаатар" },
        { value: 28, text: "Улаанбаатар - Хан-Уул" },
        { value: 29, text: "Улаанбаатар - Багахангай" },
        { value: 30, text: "Улаанбаатар - Сонгинохайрхан" },
      ],
    };
  },
  mounted() {
    this.loadProfile();
  },
  methods: {
    PacketNumber: function (l) {
      this.slide = l;
    },
    async loadProfile() {
      try {
        const { data } = await OwnerService.getProfile();
        this.data = data;
      } catch (ex) {
        Toast.fire({
          animation: true,
          icon: "error",
          title: "Сүлжээний алдаа!",
          text: "Холболтоо шалгаад дахин оролдоно уу!",
        });
      }
    },
    validateByear(value) {
      console.log(value);
      if (isNaN(value)) {
        return {
          isOk: false,
          message: "Төрсөн оныг тоогоор бичнэ үү.",
        };
      } else {
        if (value * 1 < 1900 || value * 1 > new Date().getFullYear()) {
          return {
            isOk: false,
            message: "Оныг 1900-аас энэ жил хүртлэх хүрээнд бичнэ үү.",
          };
        }
      }
      return {
        isOk: true,
        message: "",
      };
    },
    validateEmail(value) {
      const isValid = /^\w+([./-]?\w+)*@\w+([./-]?\w+)*(\.\w{2,3})+$/.test(
        value
      );
      return {
        isOk: isValid,
        message: isValid ? "" : "Зөв и-мэйл хаяг оруулна уу.",
      };
    },
  },
};
</script>

<style scoped>
.container-profile {
  background: url("../assets/images/background-class.png");
  font-family: "Roboto", sans-serif;
  width: 80%;
  padding: 50px 50px 90px 50px;
  margin-left: auto;
  margin-right: auto;
}

.card-header {
  background-color: #2ecc71;
  border-top-left-radius: 0.5em;
  border-top-right-radius: 0.5em;
  color: white;
  font-size: 1.25em;
  margin-bottom: 23px;
  text-align: center;
}
.profile {
  display: flex;
  justify-content: space-between;

  margin-left: auto;
  margin-right: auto;
  font-size: 0.9375em;
  color: #000000;
  margin-bottom: 12px;
}
.profile-flex {
  display: flex;
  float: right;
}
.form-flex {
  display: flex;
}
.edit-button {
  border-radius: 10px;
  font-size: 0.8em;
  color: #ffffff;
  background-color: #cbcbcb;
  border: none;
  display: flex;
  align-items: center;
}
.save {
  background-color: #52b700;
}
.undo {
  background-color: black;
}

.change-button {
  float: right;
  margin-top: 20px;
}
.card-body {
  padding: 0px 30px 0px 30px;
}
.card-student {
  min-height: 392px;
  position: relative;
}

/*Test card css-дээд*/
.test-card {
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 0.7em;
  border: none;
}
.test-card .card-header {
  background-color: #2ecc71;
  border-top-left-radius: 0.5em;
  border-top-right-radius: 0.5em;
  color: white;
  width: 50%;
  font-size: 1.25em;
  margin-bottom: 60px;
}
/*Test card css-доод*/

/*test choose css -доод*/
.packet-number-content {
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  padding: 15px;
}
.packet-number {
  margin: 20px;
  width: 68px;
  height: 68px;
  border-radius: 50%;
  border: 5px solid gainsboro;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 35px;
  font-family: Roboto;
  color: #ffffff;
  cursor: pointer;
  background-color: #dadde1;
}
.packet-number-active {
  background-color: #faa246;
  cursor: pointer;
}

/*test choose css -доод*/
.carousel {
  width: 100%;
  display: flex;
  justify-content: center;
}
.VueCarousel-slide-center {
  display: flex;
  justify-content: center;
}
.VueCarousel .carousel {
  display: flex;
  justify-content: center;
}
.card {
  border-radius: 1em;
  width: 100%;
  display: flex;
}
.carousel .card-body {
  display: flex;
  align-items: center;
}
a {
  color: #e20b0bad;
}
.rule-regex {
  color: #e20b0bad;
  font-size: 13px;
  max-width: 200px;
  text-align: start;
}
.confirm-password-animation {
  color: #e20b0bad;
}

.alert-error {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: #fab1a0;
  padding: 5px;
  border-radius: 3px;
  color: #e84118;
  opacity: 0.7;
}
.iserror {
  border-color: red;
}
.success {
  background-color: #52b700;
  color: #ffffff;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.empty-card {
  min-height: 250px;
  vertical-align: middle;
}
</style>
